import { render, staticRenderFns } from "./RetainModal.vue?vue&type=template&id=16cb3cbe&scoped=true&"
import script from "./RetainModal.vue?vue&type=script&lang=js&"
export * from "./RetainModal.vue?vue&type=script&lang=js&"
import style0 from "./RetainModal.vue?vue&type=style&index=0&id=16cb3cbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb3cbe",
  null
  
)

export default component.exports